import { GitHubIcon, GitlabIcon, Linkedin } from "../images";

export const GIT_CARDS = [
  {
    icon: <GitlabIcon />,
    title: "GitLab",
    urlTitle: "View profile",
    url: "https://gitlab.com/ulugbek01081999",
    order: "order-1",
  },
  {
    icon: <Linkedin />,
    title: "Linkedin",
    urlTitle: "View profile",
    url: "https://www.linkedin.com/in/ulug-bek-bozarov-043354249/",
    order: "order-3 order-md-2",
  },
  {
    icon: <GitHubIcon />,
    title: "GitHub",
    urlTitle: "View profile",
    url: "https://github.com/UlugbekBozarov",
    order: "order-2 order-md-3",
  },
];
